import { initContract } from "@ts-rest/core";
import { StreamableFile } from "@nestjs/common";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    form1099NecReportQuerySchema,
    form1099ReportResponseSchema,
    track1099CsvQuerySchema,
} from "@common/schemas/domains/tax/form1099-report.schema";

const c = initContract();

export const taxReportsContract = c.router(
    {
        /** @deprecated No client uses this; use `get1099NecReport` / `get1099NecTrack1099Csv`. */
        get1099Report: {
            method: "GET",
            path: "/1099",
            deprecated: true,
            query: z.object({
                workspaceId: z.string().uuid(),
            }),
            responses: {
                200: c.type<StreamableFile>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        get1099NecReport: {
            method: "GET",
            path: "/1099-nec",
            query: form1099NecReportQuerySchema,
            responses: {
                200: form1099ReportResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        get1099NecTrack1099Csv: {
            method: "GET",
            path: "/1099-nec/track1099.csv",
            query: track1099CsvQuerySchema,
            responses: {
                200: c.type<StreamableFile>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/tax-reports",
    },
);
